<template>
  <div id="printCards" style="width: 210mm; height: 297mm">
    <div
      style="
        display: grid;
        grid-template-columns: repeat(2, 2fr);
        justify-content: space-between;
      "
    >
      <div
        v-for="(card, i) in data"
        :key="i"
        :style="`position: relative; margin-bottom: ${
          i % 8 == 2 ? '2' : '3.8'
        }mm`"
      >
        <img
          src="@/assets/card.png"
          style="width: 102.9mm; height: 70.4mm; text-align: left"
        />
        <img
          v-if="card.prefecture_logo"
          :src="$store.state.urlImages + card.prefecture_logo"
          style="
            width: 25mm;
            height: 25mm;
            position: absolute;
            top: 110px;
            left: 275px;
          "
        />
        <div
          style="
            width: 40mm;
            height: 16mm;
            position: absolute;
            bottom: 28mm;
            left: 25px;
          "
        >
          <p class="card-subtitle">{{ card.prefecture_social_name }}</p>
          <p class="card-subtitle">{{ card.sec_name }}</p>
          <p class="card-subtitle">Veículo: {{ card.model_desc }}</p>
          <p class="card-subtitle">Placa: {{ card.vehicle_board }}</p>
          <p class="card-subtitle">Senha: {{ card.vehicle_password }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import passCard from "./passCard";
export default {
  // components: { passCard },
  props: ["data"],
};
</script>
